import React from 'react';

import {
  ChevronDownRegularIcon,
  ChevronUpRegularIcon
} from '../../../../shared/icons/icons';

import './select-toggle.scss';

interface SelectToggleProps {
  selectProps: {
    isDisabled: boolean;
    menuIsOpen: boolean;
  };
}

function SelectToggle(props: SelectToggleProps) {
  const {
    selectProps: { isDisabled, menuIsOpen: isOpen }
  } = props;

  const styleName = `container ${isDisabled ? 'isDisabled' : ''}`;

  return isOpen ? (
    <ChevronUpRegularIcon className="select-toggle" styleName={styleName} />
  ) : (
    <ChevronDownRegularIcon className="select-toggle" styleName={styleName} />
  );
}

export default SelectToggle;
